export {default} from './MailingListModel';
export * from './MailingListModel';



// WEBPACK FOOTER //
// ./src/models/MailingListModel/index.ts